import { INSIGHTS_T } from "@/lib/i18nInsights";
// Translation dictionary. Tamil strings are authored — NOT machine-translated at runtime.
export const T = {
  en: {
    app_title: "Tamil Nadu Legislative Assembly",
    headline: "Know Your Leaders",
    vote_info: "2026 Assembly results · 234 constituencies",
    demo_banner: "Demo — Sample Data.  Real data:",
    real_myneta: "MyNeta.info",
    real_eci: "ECI Affidavits",
    search_placeholder: "Search your constituency...",
    choose_constituency: "Choose Constituency",
    search_your_constituency_above: "Search your constituency above",
    search_your_constituency: "Search Your Constituency",
    see_all_caption: "See all candidates, their assets, education & criminal records",
    sample_constituencies: "Sample constituencies:",
    tap_card_hint: "Tap any card to see assets & details",
    no_candidates_title: "No candidates found",
    no_candidates_sub: "We could not find candidates for this constituency in the current dataset.",
    back_home: "← Back to search",
    party: "Party",
    candidate: "Candidate",
    constituency: "Constituency",
    candidates: "Candidates",
    alliance: "Alliance",
    age_label: "Age",
    total_assets: "Total Assets",
    liabilities: "Liabilities",
    education: "Education",
    criminal_cases: "Criminal Cases",
    criminal_record: "Criminal Record",
    no_cases: "No Cases",
    cases: "Cases",
    view_more: "View Additional Details",
    district_suffix: "District",
    independent: "Independent",
    dmk_alliance: "DMK Alliance",
    aiadmk_alliance: "AIADMK Alliance",
    lang_en: "English",
    lang_ta: "தமிழ்",
    clear: "Clear",
    not_available: "Not available",
    footer_prefix: "All data sourced from",
    footer_and: "and",
    footer_eci: "ECI Affidavits",
    quote_text: "For the People. By the People.",
    home_btn: "Home",
    share_label: "Share:",
    contact_link: "Contact us",
    contact_title: "Contact us",
    contact_sub: "Questions, data corrections, or feedback? Send us a note.",
    contact_back: "Back",
    contact_email: "Your Email",
    contact_contact_id: "Name / Phone",
    contact_contact_id_placeholder: "How should we address you?",
    contact_message: "Your Message",
    contact_message_placeholder: "Write your message here…",
    contact_submit: "Send Message",
    contact_sending: "Sending…",
    contact_success_title: "Message received",
    contact_success_sub: "Thanks — we'll get back to you if needed.",
    contact_send_another: "Send another",
    about_link: "About me",
    media_link: "In the news",
    media_badge: "As featured in NDTV, The Hindu BL & more",
    about_title: "About me",
    about_name: "Kapil Bhaskar",
    about_subtitle: "Grade 12 · Vidya Mandir Senior Secondary School · Chennai",
    about_p1:
      "I am Kapil Bhaskar, a grade 12 student from Vidya Mandir Senior Secondary School. I enjoy a good game of cricket and basketball and am a lifelong fan of CSK (Whistle Podu always!).",
    about_p2:
      "I live in Chennai with my parents, my older brother and my cat Simba.",
    about_p3:
      "NeeYosi is the result of a passion project — where I felt details of our elected thalaivas should be more accessible to the common man in the local language. I enjoy Statistics and using it to solve real-world problems, and NeeYosi is a small step in that attempt.",
    disclaimer_title: "Disclaimer —",
    disclaimer_text:
      "The information provided on this website is intended solely for general awareness and informational purposes. While reasonable efforts have been made to ensure accuracy and reliability of data, the website does not guarantee the correctness, completeness or timeliness of such information. The users are strongly encouraged to independently verify all information including candidate details and all other associated electoral data from official sources. The website shall not be held responsible for any errors, omissions or reliance placed on the information provided herein. By using this website you acknowledge that the responsibility to make an informed electoral choice rests solely with you.",
    alliance_overview_title: "Tamil Nadu Election Alliances",
    alliance_overview_sub: "Who stands with whom in 2026",
    dmk_alliance_desc: "Secular Progressive Alliance — led by DMK",
    aiadmk_alliance_desc: "NDA Alliance — led by AIADMK",
    solo_alliance_desc: "Major parties contesting alone",
    parties_count: "parties",
    share_candidate: "Share",
    share_copied: "Link copied!",
    share_message:
      "NeeYosi — Know Your Candidate. Do you know who you're voting for? Does {name} have a criminal record? Is {name} educated? {party} · {constituency}.",
  },
  ta: {
    app_title: "தமிழ்நாடு சட்டமன்றப் பேரவை",
    headline: "உங்கள் தலைவர்களை அறியுங்கள்",
    vote_info: "2026 சட்டமன்றத் தேர்தல் முடிவுகள் · 234 தொகுதிகள்",
    demo_banner: "டெமோ — மாதிரி தரவு.  உண்மையான தரவு:",
    real_myneta: "MyNeta.info",
    real_eci: "ECI அறிக்கைகள்",
    search_placeholder: "உங்கள் தொகுதியைத் தேடுங்கள்...",
    choose_constituency: "தொகுதியைத் தேர்ந்தெடுக்கவும்",
    search_your_constituency_above: "மேலே உங்கள் தொகுதியைத் தேடுங்கள்",
    search_your_constituency: "உங்கள் தொகுதியைத் தேடுங்கள்",
    see_all_caption:
      "அனைத்து வேட்பாளர்கள், அவர்களின் சொத்துகள், கல்வி மற்றும் குற்றப் பதிவுகளைப் பார்க்கவும்",
    sample_constituencies: "மாதிரி தொகுதிகள்:",
    tap_card_hint: "சொத்துக்கள் மற்றும் விவரங்களைக் காண எந்த அட்டையையும் தட்டவும்",
    no_candidates_title: "வேட்பாளர்கள் யாரும் கிடைக்கவில்லை",
    no_candidates_sub:
      "தற்போதைய தரவில் இந்தத் தொகுதிக்கான வேட்பாளர்களை எங்களால் கண்டுபிடிக்க முடியவில்லை.",
    back_home: "← தேடலுக்குத் திரும்பு",
    party: "கட்சி",
    candidate: "வேட்பாளர்",
    constituency: "தொகுதி",
    candidates: "வேட்பாளர்கள்",
    alliance: "கூட்டணி",
    age_label: "வயது",
    total_assets: "மொத்த சொத்துக்கள்",
    liabilities: "பொறுப்புகள்",
    education: "கல்வி",
    criminal_cases: "குற்ற வழக்குகள்",
    criminal_record: "குற்றப் பதிவு",
    no_cases: "வழக்குகள் இல்லை",
    cases: "வழக்குகள்",
    view_more: "மேலதிக விவரங்களைக் காண்க",
    district_suffix: "மாவட்டம்",
    independent: "சுயேட்சை",
    dmk_alliance: "திமுக கூட்டணி",
    aiadmk_alliance: "அதிமுக கூட்டணி",
    lang_en: "English",
    lang_ta: "தமிழ்",
    clear: "அழி",
    not_available: "இல்லை",
    footer_prefix: "அனைத்து தரவுகளும் பெறப்பட்டவை:",
    footer_and: "மற்றும்",
    footer_eci: "ECI அறிக்கைகள்",
    quote_text: "மக்களுக்காக. மக்களால்.",
    home_btn: "முகப்பு",
    share_label: "பகிர்:",
    contact_link: "தொடர்பு கொள்ள",
    contact_title: "எங்களைத் தொடர்பு கொள்ள",
    contact_sub: "கேள்விகள், தரவு திருத்தங்கள், கருத்துகள்? எங்களுக்கு எழுதுங்கள்.",
    contact_back: "திரும்பு",
    contact_email: "உங்கள் மின்னஞ்சல்",
    contact_contact_id: "பெயர் / தொலைபேசி",
    contact_contact_id_placeholder: "உங்களை எப்படி அழைக்கலாம்?",
    contact_message: "உங்கள் செய்தி",
    contact_message_placeholder: "உங்கள் செய்தியை இங்கே எழுதவும்…",
    contact_submit: "செய்தியை அனுப்பு",
    contact_sending: "அனுப்புகிறது…",
    contact_success_title: "செய்தி பெறப்பட்டது",
    contact_success_sub: "நன்றி — தேவைப்பட்டால் நாங்கள் உங்களை தொடர்பு கொள்கிறோம்.",
    contact_send_another: "மற்றொரு செய்தி அனுப்பு",
    about_link: "என்னைப் பற்றி",
    media_link: "ஊடகக் குறிப்புகள்",
    media_badge: "NDTV, The Hindu BL மற்றும் பல ஊடகங்களில் இடம்பெற்றது",
    about_title: "என்னைப் பற்றி",
    about_name: "கபில் பாஸ்கர்",
    about_subtitle: "12ஆம் வகுப்பு · வித்யா மந்திர் மேல்நிலைப் பள்ளி · சென்னை",
    about_p1:
      "நான் கபில் பாஸ்கர். வித்யா மந்திர் மேல்நிலைப் பள்ளியில் 12ஆம் வகுப்பு படிக்கிறேன். கிரிக்கெட் மற்றும் பாஸ்கெட்பால் விளையாடுவதை விரும்புகிறேன். CSK-வின் வாழ்நாள் ரசிகன் (விசில் போடு எப்போதும்!).",
    about_p2:
      "என் பெற்றோர், மூத்த சகோதரர் மற்றும் என் பூனை சிம்பாவுடன் சென்னையில் வசிக்கிறேன்.",
    about_p3:
      "NeeYosi ஒரு ஆர்வ திட்டத்தின் விளைவு — நாம் தேர்ந்தெடுக்கும் தலைவர்களின் விவரங்கள் பொது மக்களுக்கு அவர்களின் தாய்மொழியில் எளிதாகக் கிடைக்க வேண்டும் என்று நான் உணர்ந்தேன். புள்ளியியலை விரும்புகிறேன், அதை உண்மை உலகப் பிரச்சனைகளுக்குப் பயன்படுத்துவதை ரசிக்கிறேன் — NeeYosi அந்த முயற்சியின் ஒரு சிறிய காலடி.",
    disclaimer_title: "பொறுப்புத்துறப்பு —",
    disclaimer_text:
      "இந்த இணையதளத்தில் வழங்கப்பட்டுள்ள தகவல்கள் பொது விழிப்புணர்வு மற்றும் தகவல் நோக்கங்களுக்காக மட்டுமே வழங்கப்படுகின்றன. தரவின் துல்லியம் மற்றும் நம்பகத்தன்மையை உறுதிசெய்ய நியாயமான முயற்சிகள் எடுக்கப்பட்டாலும், இத்தகவல்களின் சரிவரம், முழுமை அல்லது சமகாலத்தன்மையை இந்த இணையதளம் உத்தரவாதம் தரவில்லை. வேட்பாளர் விவரங்கள் மற்றும் தொடர்புடைய அனைத்து தேர்தல் தரவுகள் உட்பட அனைத்து தகவல்களையும் அதிகாரப்பூர்வ ஆதாரங்களில் இருந்து சுயாதீனமாக சரிபார்த்துக் கொள்ளுமாறு பயனர்கள் வலுவாக ஊக்குவிக்கப்படுகிறார்கள். இங்கே வழங்கப்பட்ட தகவல்களில் ஏற்படும் பிழைகள், விடுபடுதல்கள் அல்லது நம்பிக்கை வைப்பதற்கு இந்த இணையதளம் பொறுப்பேற்காது. இந்த இணையதளத்தைப் பயன்படுத்துவதன் மூலம், தகவலறிந்த தேர்தல் தெரிவைச் செய்யும் பொறுப்பு முற்றிலும் உங்களிடமே உள்ளது என்பதை நீங்கள் ஒப்புக்கொள்கிறீர்கள்.",
    alliance_overview_title: "தமிழ்நாடு தேர்தல் கூட்டணிகள்",
    alliance_overview_sub: "2026-இல் யார் யாருடன்",
    dmk_alliance_desc: "மதச்சார்பற்ற முற்போக்கு கூட்டணி — திமுக தலைமையில்",
    aiadmk_alliance_desc: "NDA கூட்டணி — அதிமுக தலைமையில்",
    solo_alliance_desc: "தனியாக போட்டியிடும் முக்கிய கட்சிகள்",
    parties_count: "கட்சிகள்",
    share_candidate: "பகிர்",
    share_copied: "இணைப்பு நகலெடுக்கப்பட்டது!",
    share_message:
      "நீயோசி — உங்கள் வேட்பாளரை அறியுங்கள். {name} அவர்களுக்குக் குற்றப் பதிவு உள்ளதா? அவர் படித்தவரா? {party} · {constituency}.",
  },
};
Object.assign(T.en, INSIGHTS_T.en);
Object.assign(T.ta, INSIGHTS_T.ta);

// Tamil transliterations for common educational qualifications (so age/numbers are NOT translated but text labels can be)
export const EDUCATION_TA = {
  "10th pass": "10ஆம் வகுப்பு",
  "8th pass": "8ஆம் வகுப்பு",
  "12th pass": "12ஆம் வகுப்பு",
  graduate: "பட்டதாரி",
  "post graduate": "முதுகலை",
  literate: "எழுத்தறிவு",
  illiterate: "எழுத்தறிவற்ற",
  others: "மற்றவை",
  doctorate: "முனைவர்",
  "graduate professional": "பட்டப்படிப்பு தொழில்முறை",
};

export function translateEducation(edu, lang) {
  if (!edu) return "—";
  if (lang === "en") return edu;
  const key = edu.trim().toLowerCase();
  return EDUCATION_TA[key] || edu;
}
